import React from 'react';
import { Link } from 'gatsby';
import useScroll from '../../../hooks/useScroll';

import Burger from './Burger/Burger';
import Navigation from './Navigation/Navigation';
import Logo from '../../../images/ZeroTabletopBianco.png';

const Header = () => {
  const [open, setOpen] = React.useState(false);
  const [activeScroll, setActiveScroll] = React.useState(false);

  function menuToggle() {
    setOpen(!open);
  }

  const changePosition = 100;
  let scroller = useScroll();

  if (scroller > changePosition && !activeScroll) {
    setActiveScroll(true);
  }

  if (scroller <= changePosition && activeScroll) {
    setActiveScroll(false);
  }

  return (
    <>
      <header className={activeScroll || open ? 'header is-active' : 'header'}>
        <div className="app-container">
          <div className="header__wrapper">
            <Link className="logo__link" to="/">
              <img className="header__logo" src={Logo} alt="Zero Tabletop Productions" />
            </Link>
            <Burger menuToggle={menuToggle} open={open} />
          </div>
        </div>
      </header>
      <Navigation menuToggle={menuToggle} open={open} />
    </>
  );
};

export default Header;
